
            const data = {"name":"glyph/24/chevron-up","data":{"width":"24","height":"24","viewBox":"0 0 18 18","data":"<path pid=\"0\" d=\"M9.53 4.72a.75.75 0 0 0-1.061 0L2.22 10.97a.75.75 0 1 0 1.061 1.061l5.72-5.72 5.72 5.72a.748.748 0 0 0 1.06 0 .75.75 0 0 0 0-1.061l-6.25-6.25Z\" _fill=\"#212121\" class=\"nc-icon-wrapper\"/>","originalColors":[{"type":"fill","color":"#212121"}],"stopColors":[]}}
        
                    module.exports = data
                    